





























































import { defineComponent, PropType, ref, computed, useRouter, useContext, useFetch } from '@nuxtjs/composition-api';
import { useLicensePlateFinder } from '../composables/useLicensePlateFinder';
import { usePartFinderStore } from '../stores/partFinder';
import { storeToRefs } from 'pinia';
import type { LicensePlate } from '../composables/useLicensePlateRegistration';
import { SfHeading, SfProperty, SfButton, SfLoader } from '@storefront-ui/vue';
import WmSelect from 'components/theme/Form/Select.vue';

export default defineComponent({
  name: 'LicensePlate',
  props: {
    plate: {
      type: Object as PropType<LicensePlate>,
      required: true
    }
  },
  components: {
    SfHeading,
    SfProperty,
    SfButton,
    SfLoader,
    WmSelect
  },
  emits: ['remove', 'details'],
  setup (props) {
    const { localeRoute } = useContext();
    const plate = props.plate as LicensePlate;
    const finderId = ref<number | null>(null);

    const { loading, getMMYInfo } = useLicensePlateFinder();

    const router = useRouter();
    const store = usePartFinderStore();
    const { finders } = storeToRefs(store);
    const traktor = computed(() => {
      return finders.value.find((finder) => finder.finder_id === 1);
    });
    const findersOptions = computed(() => {
      return finders.value?.map(f => ({ value: f.finder_id, label: f.name })) || [];
    });

    useFetch(async () => {
      if (!finders.value?.length) {
        await store.loadFinders();
      }

      // Only set finderId after finders are loaded
      if (traktor.value) {
        finderId.value = traktor.value.finder_id;
      }
    })

    async function findMMYInfo() {
      if (!plate.brand || !plate.model) {
        return;
      }
      const info = await getMMYInfo({ brand: plate.brand, finder_id: finderId.value, model: plate.model });
      if (info.brand && info.finder && info.model) {
        const route = localeRoute({
          name: 'part-finder-parts',
          params: {
            brand: info.brand.slug,
            finder: info.finder.slug,
            model: info.model.slug
          }
        });
        router.push(route);
      } else if (info.brand) {
        const route = localeRoute({
          name: 'part-finder-models',
          params: {
            finder: info.finder.slug,
            brand: info.brand.slug
          }
        });
        router.push(route);
      } else if (info.finder) {
        const route = localeRoute({
          name: 'part-finder-finders',
          params: {
            finder: info.finder.slug
          }
        });
        router.push(route);
      } else {
        router.push(localeRoute({ name: 'part-finder' }));
      }
    }

    return {
      findMMYInfo,
      finderId,
      findersOptions,
      loading,
      traktor
    }
  }
});
